// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgFollowRun24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M16.4777 3.93675C16.2664 4.47892 15.6557 4.74718 15.1135 4.53594C14.5713 4.3247 14.3031 3.71395 14.5143 3.17178C14.7255 2.6296 15.3363 2.36133 15.8785 2.57257C16.4206 2.78381 16.6889 3.39457 16.4777 3.93675ZM17.8753 4.4813C17.3633 5.79537 15.883 6.4456 14.5689 5.93361C13.2549 5.42162 12.6046 3.9413 13.1166 2.62722C13.6286 1.31314 15.109 0.662912 16.423 1.17491C17.7371 1.6869 18.3873 3.16722 17.8753 4.4813ZM12.7991 7.07119C12.8995 6.81346 12.8499 6.52139 12.6701 6.31123C12.4902 6.10109 12.2093 6.007 11.9392 6.06641L7.94272 6.94532C7.6978 6.99919 7.49601 7.17189 7.40498 7.40555L6.16892 10.578C6.01855 10.9639 6.20952 11.3987 6.59547 11.5491C6.98143 11.6995 7.41621 11.5085 7.56658 11.1225L8.65692 8.32411L10.8927 7.83241L9.95941 10.2278C9.81283 10.604 9.70614 11.1945 9.863 11.8025C10.0316 12.4561 10.4919 13.0672 11.3541 13.4032C12.0146 13.6605 13.0814 14.3356 13.7852 15.6102C14.4771 16.8631 14.8669 18.7833 14.0439 21.6362C13.929 22.0342 14.1586 22.4499 14.5566 22.5648C14.9546 22.6796 15.3703 22.45 15.4851 22.052C16.3994 18.8828 16.0133 16.5421 15.0983 14.8851C14.1954 13.2499 12.8244 12.3662 11.8987 12.0055C11.492 11.8471 11.3651 11.6205 11.3154 11.4277C11.2539 11.1894 11.2976 10.9249 11.357 10.7724L12.7991 7.07119ZM14.7813 7.07978C15.195 7.10039 15.5137 7.45247 15.4931 7.86617C15.4749 8.23085 15.6289 8.78737 16.2342 9.17288C16.8589 9.57073 18.0952 9.86913 20.3991 9.36246C20.8036 9.27349 21.2037 9.52933 21.2927 9.93383C21.3816 10.3384 21.1258 10.7385 20.7213 10.8274C18.2293 11.3755 16.5278 11.1382 15.4284 10.4381C14.3097 9.72556 13.9536 8.62168 13.9949 7.79153C14.0155 7.37783 14.3676 7.05918 14.7813 7.07978ZM10.9725 14.8857C11.1229 14.4997 10.9319 14.0649 10.5459 13.9146C10.16 13.7642 9.72523 13.9552 9.57486 14.3411C9.4522 14.6559 9.05176 15.1895 8.20546 15.473C7.36568 15.7543 6.02377 15.8067 4.02248 15.0269C3.63652 14.8766 3.20174 15.0675 3.05137 15.4535C2.90099 15.8394 3.09197 16.2742 3.47792 16.4246C5.70658 17.2929 7.42041 17.3179 8.68188 16.8953C9.93683 16.475 10.6831 15.6283 10.9725 14.8857Z"
				/>
			</Svg>
		);
	}
);
SvgFollowRun24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgFollowRun24;
